import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useDailyReportStore } from "../store/useDailyReportStore";
import DailyReportView from "../components/reports/DailyReportView";

const PublicDailyReportView = () => {
  const { token } = useParams();
  const { current, fetchByToken, loading } = useDailyReportStore();

  useEffect(() => {
    if (token) fetchByToken(token);
  }, [token, fetchByToken]);

  if (loading && !current) {
    return (
      <div className="min-h-screen bg-[#f8f9ff] grid place-items-center p-4">
        <div className="text-slate-400 text-[14px] inline-flex items-center gap-2">
          <Loader2 size={18} className="animate-spin" />
          Loading report...
        </div>
      </div>
    );
  }

  if (!current) {
    return (
      <div className="min-h-screen bg-[#f8f9ff] grid place-items-center p-4">
        <div className="text-center text-slate-500">
          <p className="text-[16px] font-bold mb-1">Report not found</p>
          <p className="text-[13px]">
            This link may have been revoked or never existed.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f8f9ff] py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <DailyReportView report={current} publicView />
      </div>
    </div>
  );
};

export default PublicDailyReportView;
